import { ApiResult, HttpClient } from "../http.js";
import { KlsTaskDto, KlsTaskStatus } from "../types/kls-tasks.js";

export interface ChangeKlsTaskStatusPayload {
  newStatus: KlsTaskStatus;
  reason?: string | null;
}

export interface OverrideKlsTaskPayload {
  reason: string;
}

export class KlsTasksApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<KlsTaskDto[]>> {
    return this.http.get<KlsTaskDto[]>("/api/kls-tasks");
  }

  listPending(): Promise<ApiResult<KlsTaskDto[]>> {
    return this.http.get<KlsTaskDto[]>("/api/kls-tasks/pending");
  }

  listByProject(projectId: string): Promise<ApiResult<KlsTaskDto[]>> {
    return this.http.get<KlsTaskDto[]>(`/api/projects/${encodeURIComponent(projectId)}/kls-tasks`);
  }

  get(id: string): Promise<ApiResult<KlsTaskDto>> {
    return this.http.get<KlsTaskDto>(`/api/kls-tasks/${encodeURIComponent(id)}`);
  }

  /**
   * POST /api/projects/{projectId}/kls-tasks/generate
   * Materialises the org's KLS task templates for a project. Idempotent — returns the
   * number of tasks created, and 0 when the project already has auto-generated tasks.
   * Replaces the `createKLSTasksManually` Cloud Function.
   */
  generateForProject(projectId: string): Promise<ApiResult<number>> {
    return this.http.post<number>(
      `/api/projects/${encodeURIComponent(projectId)}/kls-tasks/generate`,
    );
  }

  changeStatus(id: string, payload: ChangeKlsTaskStatusPayload): Promise<ApiResult<string>> {
    return this.http.post<string>(`/api/kls-tasks/${encodeURIComponent(id)}/status`, { body: payload });
  }

  override(id: string, payload: OverrideKlsTaskPayload): Promise<ApiResult<string>> {
    return this.http.post<string>(`/api/kls-tasks/${encodeURIComponent(id)}/override`, { body: payload });
  }
}
